import { COURSES_PRESELECTED_FILTERS } from './global/constants.js';
import { initializeBookmarks } from './elements/bookmark.js';
import { initializeDropdownSearch } from './elements/dropdown-search.js';

document.addEventListener('DOMContentLoaded', () => {
  initializeSearch();
  initializeBookmarks();
  initializePreselectedFilters();
  initializeDropdownSearch();
});

const searchFormId = 'SearchForm';
const searchInputClass = 'SearchInput';
const searchResultsClass = 'CourseProgrammes';
const searchResultsEmptyClass = 'CourseProgrammes--empty';
const searchResultItemClass = 'CourseProgramme__University';
const searchResultSubItemClass = 'CourseProgramme__University__Programme';
const searchResultItemHiddenClass = 'CourseProgramme__University--hidden';
const filterDropdownsClass = 'Filters__Dropdowns';
const filterCheckboxClass = 'Filters__Checkbox';
const clearButtonClass = 'Filters__Dropdown__Clear';
const filterButtonClass = 'Filters__Dropdown__Filter';
const hasActiveFilterClass = 'Filters__Dropdown--hasActiveFilter';

let $searchForm;
let $searchInput;
let $searchResults;
let $searchResultItems;
let $filterButtons;
let $clearButtons;
let searchFilters = {
  "region": {},
  "country": {},
  "degreeLevel": {},
  "q": ""
};


function initializeSearch() {
  $searchForm = document.querySelector(`#${searchFormId}`);
  $searchInput = document.querySelector(`.${searchInputClass}`);
  $searchResults = document.querySelector(`.${searchResultsClass}`);
  $searchResultItems = document.querySelectorAll(`.${searchResultItemClass}`);
  $filterButtons = document.querySelectorAll(`.${filterButtonClass}`);
  $clearButtons = document.querySelectorAll(`.${clearButtonClass}`);

  if (!$searchForm || !$searchResults || !$searchResultItems.length) {
    return;
  }

  $searchForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const query = $searchInput.value;
    searchFilters.q = query;
    filterSearchResults();
  });

  $filterButtons.forEach(($filterButton) => {
    $filterButton.addEventListener('click', (e) => {
      e.preventDefault();
      searchFilters[e.target.dataset.field] = {};
      const $filterContainer = e.target.closest('.Filters__Dropdown');
      if (e.target.dataset.field == 'region') {
        searchFilters.country = {};
        const $countryCheckboxes = document.querySelectorAll(`input[name='country']:checked`);
        if ($countryCheckboxes) {
          $countryCheckboxes.forEach($country => {
            $country.checked = false;
          });
          updateDropdownCounter(document.querySelector(`.${filterButtonClass}[data-field='country']`));
        }
      }
      const $checkboxes = $filterContainer.querySelectorAll(`.${filterCheckboxClass}:checked`);
      $checkboxes.forEach($checkbox => {
        searchFilters[$checkbox.name][$checkbox.value] = true;
      });
      updateDropdownCounter(e.target);
      filterSearchResults();
    })
  });
  $clearButtons.forEach(($clearButton) => {
    $clearButton.addEventListener('click', (e) => {
      e.preventDefault();
      searchFilters[e.target.dataset.field] = {};
      const $filterContainer = e.target.closest('.Filters__Dropdown');
      const $checkboxes = $filterContainer.querySelectorAll(`.${filterCheckboxClass}:checked`);
      $checkboxes.forEach($checkbox => {
        $checkbox.checked = false;
      });
      updateDropdownCounter(e.target);
      filterSearchResults();
    })
  });
}

function updateDropdownCounter(actionButton) {
  const closestButton = actionButton.closest('.Filters__Dropdown');
  const countContainer = closestButton.querySelector('.Filters__Dropdown__Count');
  const totalSelected = Object.keys(searchFilters[actionButton.dataset.field]).length;
  if (totalSelected === 0) {
    countContainer.textContent = "";
    closestButton.classList.remove(hasActiveFilterClass);
  } else {
    countContainer.textContent = `(${totalSelected})`;
    closestButton.classList.add(hasActiveFilterClass);
  }
}

function filterSearchResults() {
  let hasResults = false;

  $searchResultItems.forEach($searchResult => {
    if (Object.keys(searchFilters.region).length > 0) {
      if (!searchFilters.region.hasOwnProperty($searchResult.dataset.region)) {
        $searchResult.classList.add(searchResultItemHiddenClass);
        return;
      }
    }

    if (Object.keys(searchFilters.country).length > 0) {
      if (!searchFilters.country.hasOwnProperty($searchResult.dataset.country)) {
        $searchResult.classList.add(searchResultItemHiddenClass);
        return;
      }
    }
    const $subItems = $searchResult.querySelectorAll(`.${searchResultSubItemClass}`);

    let hasSubItemResult = false;
    if (Object.keys(searchFilters.degreeLevel).length > 0) {
      $subItems.forEach($subItem => {
        if (!searchFilters.degreeLevel.hasOwnProperty($subItem.dataset.level)) {
          $subItem.classList.add(searchResultItemHiddenClass);
        } else {
          $subItem.classList.remove(searchResultItemHiddenClass);
          hasSubItemResult = true;
        }
      });
      if (!hasSubItemResult) {
        $searchResult.classList.add(searchResultItemHiddenClass);
        return;
      }
    } else {
      $subItems.forEach($subItem => {
        $subItem.classList.remove(searchResultItemHiddenClass);
      });
    }

    if (searchFilters.q) {
      if (checkIfTextMatchesQuery(searchFilters.q, $searchResult.dataset.university)) {
        $searchResult.classList.remove(searchResultItemHiddenClass);
        hasResults = true;
        return;
      } else {
        hasSubItemResult = false;
        $subItems.forEach($subItem => {
          if ($subItem.classList.contains(searchResultItemHiddenClass)) {
            return;
          }
          if (checkIfTextMatchesQuery(searchFilters.q, $subItem.dataset.programme)) {
            hasSubItemResult = true;
          } else {
            $subItem.classList.add(searchResultItemHiddenClass);
          }
        });
        if (!hasSubItemResult) {
          $searchResult.classList.add(searchResultItemHiddenClass);
          return;
        }
      }
    }
    hasResults = true;
    $searchResult.classList.remove(searchResultItemHiddenClass);
  });

  if (hasResults) {
    $searchResults.classList.remove(searchResultsEmptyClass);
  } else {
    $searchResults.classList.add(searchResultsEmptyClass);
  }
}

function checkIfTextMatchesQuery(query, text) {
  query = query.trim().toLowerCase();
  if (query.length === 0) {
    return true;
  }

  text = text.toLowerCase();

  const words = query.split(/\s+/gi);
  return words.every(word => {
    const pattern = new RegExp(`\\b${word}`, 'i');
    return pattern.test(text);
  });
}

function initializePreselectedFilters() {
  if (!localStorage.getItem(COURSES_PRESELECTED_FILTERS)) {
    return;
  }

  const checkboxes = JSON.parse(localStorage.getItem(COURSES_PRESELECTED_FILTERS));
  const $filterDropdowns = document.querySelector(`.${filterDropdownsClass}`);
  for (const key in checkboxes) {
    const preselectedCheckboxes = checkboxes[key];
    const $preselectedCheckboxes = $filterDropdowns.querySelectorAll(`.${filterCheckboxClass}[name=${key}]`);
    $preselectedCheckboxes.forEach($preselectedCheckbox => {
      if (preselectedCheckboxes.includes($preselectedCheckbox.value)) {
        $preselectedCheckbox.checked = true;
      }
    });
    $filterDropdowns.querySelector(`.${filterButtonClass}[data-field=${key}]`).click();
  }
}
